import {
  Document,
  Page,
  Text,
  View,
  Image,
  StyleSheet,
} from "@react-pdf/renderer";
import { FunctionComponent } from "react";

const styles = StyleSheet.create({
  page: {
    position: "relative",
    padding: 0,
    margin: 0,
  },
  background: {
    position: "absolute",
    top: 0,
    left: 0,
    width: 842,
    height: 595,
  },
  name: {
    position: "absolute",
    top: 238,           // adjust vertically
    left: 0,
    right: 0,
    textAlign: "center",
    fontSize: 36,
    fontFamily: "Times-Roman",
  },
date: {
    position: "absolute",
    bottom: 150,           // adjust vertically
    left: 225,
    textAlign: "center",
    fontSize: 18,
    fontFamily: "Times-Roman",
  },
});


interface IBasicFinancialPassProps {
    name: string;
    background: string;
}

const BasicFinancialPass: FunctionComponent<IBasicFinancialPassProps> = ({ name, background }) => (
  <Document>
    <Page size="A4" orientation="landscape" style={styles.page}>
    <Image
        src={{ uri: background }}
        style={styles.background}
    />

    <Text style={styles.name} wrap={false}>
        {name}
    </Text>
    <Text style={styles.date} wrap={false}>
        {new Date().toLocaleDateString()}
    </Text>
    </Page>
  </Document>
);

export default BasicFinancialPass;
